import React, {useEffect, useState, useRef} from 'react';
import ReactToPrint from 'react-to-print';
import '../App.css';
import Axios from 'axios';
import Bodyheaderloged from './bodyheaderloged'
import webpayimg from '../media/webpay.png'
import Barcode from 'react-barcode'
import headerimglogo1 from '../media/foods.png';
import headerimglogo3 from '../media/AusolanTicket.png';
import headerimglogo2 from '../media/Genova.png';
import { Alert } from 'react-bootstrap';
import Grillabotxusersreport from './grillabotxusersreport';



function Bodyticket (props){
    const divReferencia = useRef(null);
    const [valorTicket, setValorTicket] = useState(0);
    const [valorTicketDB, setValorTicketDB] = useState(0);
    const [valorCantidad, setValorCantidad] = useState(0);
    const [valorToken, setValorToken] = useState('');
    const [valorUrl, setValorUrl] = useState('');
    const [classNameBtnPay, setClassNameBtnPay] = useState('ticketMediaPayHidden') 
    const [ticketdisponibles, setTicketdisponibles] = useState(0)
    const [ticketsBarcode, setTicketsbarcode] = useState([])
    const [cantidadImprimir, setCantidadImprimir] = useState(0)
    const [barcodeListImprimir, setBarcodeListImprimir] = useState([])
    const [classTicketPrint, setClassTicketPrint] = useState('hidden printTicket')
    const [classTicketPay, setClassTicketPay] = useState('hidden cbg-white p-6 rounded-lg shadow-lg')
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);

  

    const componentRef = useRef()

    const cantidadHandler = (e) =>{
        setCantidadImprimir(e.target.value)
        imprimeTicket(e.target.value)
    }

    const setSumaValue = (e) =>{
        setValorCantidad(valorCantidad + 1)
    }


    const setRestaValue = (e) =>{
        if(valorCantidad > 0)
        {
            setValorCantidad(valorCantidad - 1)
        }
    }

    const getTicketOrder = async(e) => {
        if(valorTicket>0)
        {
            let authsincoma = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').toString().replace('"', '')
            let userorden = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
            let response = await Axios.get(process.env.REACT_APP_URLCREATETX , { 
                        params: {
                            user: userorden.replace('"', ''),
                            authCode: authsincoma.replace('"', ''),  
                            quantity: valorCantidad, 
                            value: valorTicket 
                        },
                        headers: {
                            'Access-Control-Allow-Origin' : '*',
                            'Access-Control-Allow-Methods': 'GET, POST',
                            'Access-Control-Allow-Headers': 'Content-Type'
                        }
                }
            ).then(res => { return res.data; })
            
            if(response.MessageCode == '0')
            {                
                setValorToken(response.responsetbk.token) 
                setValorUrl(response.responsetbk.url)
                setClassNameBtnPay('ticketMediaPay')
                setClassTicketPay('cbg-white p-6 rounded-lg shadow-lg')
            }
            else
            {
                setTituloAlert('Compra Tickets Transbank')
                setTextoAlert(response.Message)
                setClaseAlert('danger')
                setAlert(true)
                setTimeout(() => {    
                    setAlert(false)
                }, 5000)
            }
        }
        else
        {

        }

            
            // Al final, cambiar el foco al siguiente div
            if (divReferencia.current) {
                divReferencia.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                console.log("Foco cambiado y vista desplazada hacia el siguiente div");
              } else {
                console.error("Referencia al div no disponible");
              }
    }

    const calculateValueSel = (e) => {
        setValorTicket(valorTicket * valorTicketDB)
    }    

    
    const cantidadList = ticketsBarcode.map((item, i) => <option key={i+1}>{i+1}</option>);

    
    const imprimeTicket = (cantidad) =>{
        let ticketsBarcodeaux = ticketsBarcode.slice(0, cantidad)

        let barcodeList = ticketsBarcodeaux.map((item, i) =>
        <div key={i} className='ticketBarCode'>
            <div key={i} className='ticketLogoLeftUp'><img key={i}  src={headerimglogo1}></img></div>
            <div key={i} className='ticketLogoCenterUp'><img  key={i} src={headerimglogo3}></img></div>
            <div key={i} className='ticketLogoRightUp'></div>
            <div key={i} className='ticketContentCodeBar'><Barcode margin={30} width={1} height={80} key={i} value={item.barcode}></Barcode></div>
            <div key={i} className='ticketLogoLeftBottom'></div>
            <div key={i} className='ticketLogoCenterBottom'></div>
            <div key={i} className='ticketLogoRightBottom'><img key={i} src={headerimglogo2}></img></div>
        </div>
        )
        
        setBarcodeListImprimir(barcodeList)
        setClassTicketPrint('printTicketView')
    }


    useEffect(() => {
        setValorTicketDB(parseInt(window.localStorage.getItem('MY_APP_STATE_PROV_VALOR').toString().replace('"', '')))  
        setValorTicket(valorCantidad * valorTicketDB)
        let userorden = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')

        Axios.get(process.env.REACT_APP_URLTICKETDISPONIBLES, {
            params: {
                mail: userorden.replace('"', ''), 
            },
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setTicketdisponibles(response.data.Ticket_disponibles)
        })

        

        Axios.get(process.env.REACT_APP_URLTICKETBARCODE, {
            params: {
                mail: userorden.replace('"', ''), 
            },
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setTicketsbarcode(response.data.Ticket_disponibles)
        })

    }, [valorTicket, valorCantidad]);


    return (
        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>

            <div className='flex justify-start w-full'>
                <div className='w-full'>
                    <div className='container mx-auto p-6 space-y-8'>
                    {/* Seccion carro compra*/}
                    <div class="flex flex-col md:flex-row bg-white rounded-lg shadow-lg p-6 h-auto space-y-6 md:space-x-6">

            
                    <div class="w-full md:w-1/3 h-auto bg-white p-4 rounded-lg shadow-md">
                    <div class="w-full h-2/3 bg-indigo-600 text-white flex items-center justify-center text-6xl md:text-8xl font-bold">
                        <span id="ticketCount">{valorCantidad}</span>
                    </div>

                    <div class="w-full h-1/3 bg-gray-200 flex items-center justify-center text-green-600 text-lg font-semibold">
                        Total: $<span id="total">{valorTicket}</span>
                    </div>
                    </div>

                  
                    <div class="w-full md:w-2/3 h-full space-y-6 rounded-lg shadow-md p-6">

                    <div class="flex items-center space-x-2">
                        <h3 class="text-lg font-semibold text-gray-800">Valor de Ticket</h3>
                    </div>

                    <div class="flex items-center space-x-2">
                        <p class="text-green-600 font-bold text-2xl">$ {valorTicketDB}</p>
                    </div>

                    <div class="flex items-center space-x-2">
                        <p class="text-gray-600 font-semibold">Tipo de ticket</p>
                    </div>

                    <div class="flex items-center space-x-2">
                        <p class="text-gray-800">Menú Tradicional</p>
                    </div>

                    <div class="flex space-y-4 md:space-y-0 md:space-x-4 flex-col md:flex-row">
                        <button
                        onClick={setSumaValue}  
                        class="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2">
                        + Agregar
                        </button>
                        <button
                        onClick={setRestaValue}  
                        class="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2">
                        - Quitar
                        </button>
                    </div>

                    <div class="flex justify-center">
                        <button
                        onClick={getTicketOrder}  
                        class="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2">
                        Comprar
                        </button>
                    </div>
                    </div>
                    </div>


                    {/* Seccion boton pago pasarelas*/}
                    <div  class={classTicketPay}>
                        {alert
                            ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                                    <Alert.Heading>{tituloAlert}</Alert.Heading>
                                        <p>
                                            {textoAlert}
                                        </p>
                            </Alert>
                        :''
                        }
                        <h2 ref={divReferencia} class="text-2xl font-semibold text-gray-800 mb-4">Métodos de Pago</h2>
                        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
                            
                            <div class="flex justify-center items-center space-x-4">    
                                <div className={classNameBtnPay}>
                                    
                                        <form method="post" action={valorUrl}>
                                            <input type="hidden" name="token_ws" value={valorToken} />
                                            <img src={webpayimg} className='imgMediaPay'></img> 
                                            <input type="submit" value="Pagar" class="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2" />
                                        </form>
                                    
                                    <div className='col col-lg-4'>

                                    </div>
                                    <div className='col col-lg-4'>

                                    </div>
                                </div>  
                            </div>

                        </div>          
                    </div>

                    {/* Seccion visualizar e imprimir tickets*/}    
                    <div class="hidden cbg-white p-6 rounded-lg shadow-lg">
                        <h2 class="text-2xl font-semibold text-gray-800 mb-4">Impresion de tickets</h2>
                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                            <div className="flex items-center space-x-4">
                                <p className='textPrintTicket'>Disponibles para impresion:</p>
                            </div>

                            {/* Campo Selección Número de Páginas */}
                            <div className="flex flex-col">
                                <p className='textPrintTicket'>{ticketdisponibles}</p>
                            </div>

                            {/* Botón Generar Reporte con Icono */}
                            <div className="flex flex-col justify-end w-full sm:w-auto">
                                <select className='safiltercontrols' onChange={cantidadHandler}>
                                    <option>Seleccione cantidad</option>
                                    {cantidadList}
                                </select>
                            </div>

                            <div className="flex flex-col justify-end w-full sm:w-auto">
                                <ReactToPrint
                                    bodyClass={'printTicketPage'}
                                    trigger={() => <button className='w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2'>Imprimir</button>} 
                                    content={() => componentRef.current}
                                    removeAfterPrint ={() => true}         
                                />
                            </div>
                        </div>
                    </div>
                    
                    {/* Seccion tickets impresos*/}
                    <div className={classTicketPrint}>
                        <div className="col col-lg-12 printTicketView">
                            <div ref={componentRef}>
                                {barcodeListImprimir}
                            </div>
                        </div>
                    </div>

                    {/* Seccion visualizar grilla de transacciones*/}    
                    <div class="cbg-white p-6 rounded-lg shadow-lg">
                        <Grillabotxusersreport />
                    </div>


                    </div>
                </div>
            </div>
        </div>

        
    )
}
export default Bodyticket



